/* =====================================================================================================================
   MJP - AVVISI TEMPORANEI (sections/mjp-alerts.liquid)
   - date decise nel browser (la pagina puo' restare in cache): un avviso fuori date sparisce, senza avvisi sparisce la barra;
   - piu' avvisi: si alternano, pausa al passaggio del mouse, al focus e mentre il riquadro e' aperto;
   - riquadro: <dialog> nativo (Esc, focus), chiusura anche toccando fuori;
   - editor: selezionando un blocco si vede quell'avviso con il suo riquadro aperto.
   La barra sta dentro <store-header>, in testa (la sposta lo script in sections/mjp-alerts.liquid): --header-height deve
   comprenderla, anche quando sparisce o cambia altezza.
   ===================================================================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toMs(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n * 1000; }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  var roots = [];
  function design() { return !!(window.Shopify && window.Shopify.designMode); }

  function init(root) {
    if (!root || root.__mjpAl) return;
    root.__mjpAl = true;
    roots.push(root);

    /* Orologio: mai indietro rispetto al render del server */
    var serverNow = toMs(root.getAttribute('data-server-now'));
    var skew = serverNow && Date.now() < serverNow ? serverNow - Date.now() : 0;
    function now() { return Date.now() + skew; }
    function live(el) {
      if (design() && el.getAttribute('data-preview') === '1') return true;
      var s = toMs(el.getAttribute('data-start')), e = toMs(el.getAttribute('data-end'));
      if (s && now() < s) return false;
      if (e && now() >= e) return false;
      return true;
    }

    var items = [], current = 0, timer = null, paused = false;
    var interval = Math.max(3, parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var headSec = root.closest('.shopify-section--header');
    function syncHeight() {
      if (headSec) document.documentElement.style.setProperty('--header-height', Math.round(headSec.clientHeight) + 'px');
    }
    if (headSec && 'ResizeObserver' in window) new ResizeObserver(syncHeight).observe(headSec);

    function refresh() {
      items = qsa(root, '[data-al-item]').filter(function (el) {
        var ok = live(el);
        if (!ok && !design()) { el.remove(); }
        return ok || design();
      });
      if (!items.length) {
        root.__mjpAlDead = true;
        root.remove();
        syncHeight();
        return false;
      }
      var many = items.length > 1;
      qsa(root, '[data-al-prev], [data-al-next]').forEach(function (b) { b.hidden = !many; });
      if (current >= items.length) current = 0;
      return true;
    }

    function paint(i, instant) {
      var prev = items[current];
      current = (i + items.length) % items.length;
      var next = items[current];
      items.forEach(function (el) {
        if (el === next) { el.hidden = false; el.classList.remove('is-leaving'); }
        else if (el === prev && !instant && !REDUCED) {
          el.classList.add('is-leaving');
          setTimeout(function () { if (el !== items[current]) { el.hidden = true; el.classList.remove('is-leaving'); } }, 450);
        } else { el.hidden = true; el.classList.remove('is-leaving'); }
      });
      root.style.setProperty('--al-nav', getComputedStyle(next).getPropertyValue('--al-fg') || '#fff');
    }

    function schedule() {
      clearTimeout(timer);
      if (items.length < 2 || paused) return;
      timer = setTimeout(function () {
        if (!refresh()) return;
        paint(current + 1);
        schedule();
      }, interval);
    }
    function pause(on) { paused = on; schedule(); }

    if (!refresh()) return;
    paint(0, true);
    schedule();

    root.addEventListener('mouseenter', function () { pause(true); });
    root.addEventListener('mouseleave', function () { if (!openDialog) pause(false); });
    root.addEventListener('focusin', function () { pause(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget) && !openDialog) pause(false); });
    var prevBtn = root.querySelector('[data-al-prev]'), nextBtn = root.querySelector('[data-al-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { paint(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { paint(current + 1); });

    /* Scorrimento laterale su mobile tra piu' avvisi */
    var tx = null;
    root.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (tx === null || items.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) { paint(current + (dx < 0 ? 1 : -1)); schedule(); }
    }, { passive: true });

    /* Tempo che manca alla fine */
    var cds = qsa(root, '[data-al-cd]');
    if (cds.length) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        cds.forEach(function (cd) {
          var item = cd.closest('[data-al-item]'), end = toMs(item && item.getAttribute('data-end'));
          var s = Math.floor((end - now()) / 1000);
          if (!end || s <= 0) { cd.hidden = true; return; }
          var d = Math.floor(s / 86400); s -= d * 86400;
          var h = Math.floor(s / 3600); s -= h * 3600;
          var m = Math.floor(s / 60); s -= m * 60;
          cd.querySelector('[data-al-cd-val]').textContent = (d > 0 ? d + 'g ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
          cd.hidden = false;
        });
      };
      tick(); setInterval(tick, 1000);
    }

    /* ---------- Riquadro ---------- */
    var openDialog = null;
    function openModal(id) {
      var dlg = document.getElementById(id);
      if (!dlg || dlg.open) return;
      if (typeof dlg.showModal !== 'function') { dlg.setAttribute('open', ''); }
      else dlg.showModal();
      openDialog = dlg;
      document.documentElement.classList.add('mjp-al-lock');
      pause(true);
    }
    function closeModal(dlg) {
      dlg = dlg || openDialog;
      if (!dlg) return;
      if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    }
    qsa(root, '.mjp-al-modal').forEach(function (dlg) {
      dlg.addEventListener('close', function () {
        if (openDialog === dlg) openDialog = null;
        document.documentElement.classList.remove('mjp-al-lock');
        pause(false);
      });
      /* Tocco sullo sfondo (fuori dal riquadro) */
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeModal(dlg);
        if (e.target.closest('[data-al-close]')) closeModal(dlg);
      });
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-al-open]');
      if (t) { e.preventDefault(); openModal(t.getAttribute('data-al-open')); }
    });

    root.__mjpAlShow = function (blockId, withModal) {
      var idx = -1;
      items.forEach(function (el, i) { if (el.getAttribute('data-block-id') === blockId) idx = i; });
      if (idx < 0) return;
      paint(idx, true);
      pause(true);
      if (withModal) { closeModal(); openModal('mjp-al-modal-' + blockId); }
    };
    root.__mjpAlRelease = function () { closeModal(); pause(false); };
  }

  function boot() { qsa(document, '[data-mjp-alerts]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Editor del tema: la barra ricaricata viene spostata di nuovo nell'header dal suo script; se si ricarica l'header,
     la barra (rimasta in memoria) torna dentro quello nuovo */
  document.addEventListener('shopify:section:load', function (e) {
    /* Avvisi ricaricati dall'editor (es. cambio colori): se lo script inline non e' stato eseguito, la barra nuova e'
       rimasta nella sua sezione; va nell'header al posto di quella vecchia */
    var fresh = e.target.querySelector && e.target.querySelector('[data-mjp-alerts]');
    var hd = document.querySelector('.shopify-section--header store-header, .shopify-section--header .header');
    if (fresh && hd && !hd.contains(fresh)) {
      qsa(hd, '[data-mjp-alerts]').forEach(function (o) { o.__mjpAlDead = true; o.remove(); });
      hd.insertBefore(fresh, hd.firstChild);
    }
    if (e.target.classList && e.target.classList.contains('shopify-section--header')) {
      var head = e.target.querySelector('store-header, .header');
      roots.forEach(function (r) {
        if (head && !r.isConnected && !r.__mjpAlDead) {
          head.insertBefore(r, head.firstChild);
          document.documentElement.style.setProperty('--header-height', Math.round(e.target.clientHeight) + 'px');
        }
      });
    }
    boot();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-al-item]');
    var root = item && item.closest('[data-mjp-alerts]');
    if (root && root.__mjpAlShow) root.__mjpAlShow(item.getAttribute('data-block-id'), true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-mjp-alerts]');
    if (root && root.__mjpAlRelease) root.__mjpAlRelease();
  });
})();
